import React, { useState } from 'react';
import { FiPlus, FiBriefcase } from 'react-icons/fi';
import BankSidebar from '../components/BankSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [
  { ref: 'BA-001', name: 'Bank of China', number: '-', type: 'Current', currency: 'HKD', balance: '0.00', status: 'Active' }
];

export default function BankAccounts() {
  const [data, setData] = useLocalState('bank_accounts_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'ref', direction: 'asc' });

  const handleAdd = (newData) => { setData([{ ...newData, balance: '0.00', status: 'Active' }, ...data]); };
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <BankSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1 text-gray-800">
          <div className="flex items-center space-x-2">
            <FiBriefcase className="text-xl opacity-70 text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Bank Accounts ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded shadow-sm hover:bg-blue-900 transition-colors">
            <FiPlus className="text-sm" />
          </button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black shadow-sm">
          <table className="min-w-full border-collapse text-[12px] text-gray-800">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900 select-none">
                <th onClick={() => handleSort('ref')} className="font-normal p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('name')} className="font-normal p-2 border border-black text-left cursor-pointer">Bank Name</th>
                <th onClick={() => handleSort('number')} className="font-normal p-2 border border-black text-left cursor-pointer">Account Number</th>
                <th onClick={() => handleSort('type')} className="font-normal p-2 border border-black text-left cursor-pointer">Type</th>
                <th onClick={() => handleSort('balance')} className="font-normal p-2 border border-black text-right cursor-pointer">Balance</th>
                <th className="font-normal p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="bg-white hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-black">{row.ref}</td>
                  <td className="p-2 border border-black font-medium">{row.name}</td>
                  <td className="p-2 border border-black">{row.number}</td>
                  <td className="p-2 border border-black">{row.type}</td>
                  <td className="p-2 border border-black text-right font-bold">{row.balance}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-green-100 text-green-800 px-2 py-0.5 rounded">{row.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Bank Account" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'name', label: 'Bank Name' }, { name: 'number', label: 'Account Number' }, { name: 'type', label: 'Type (Current/Savings)' }
        ]} />
      </div>
    </div>
  );
}